export class MissingDataError extends Error {
  constructor(breadCrumbs: string) {
    super();
    this.name = 'MissingDataError';
    this.message = breadCrumbs;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, MissingDataError);
    }
  }
}
